export const jobDependencySelectItems = [
  {label: 'Use all files', key: 'all'},
  {label: "Don't use files", key: 'not_use'},
]
